import { ArrowRight, TrendingUp, Briefcase } from "lucide-react";
import { Reveal } from "./Reveal";
import { trackCTAClick } from "@/lib/analytics";

export const ProductFamilies = () => (
    <section
        data-testid="product-families-section"
        className="bg-white py-24 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <Reveal>
                <p className="text-sm font-semibold uppercase tracking-wider text-[#2563EB]">
                    Product Families
                </p>
                <h2 className="mt-3 max-w-2xl text-3xl font-bold tracking-tight text-[#0B1F44] lg:text-4xl">
                    More than growth.
                </h2>
                <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#4B5563]">
                    FlowPilot currently has two product families.
                </p>
            </Reveal>
            <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3">
                <Reveal className="lg:col-span-2">
                    <div
                        data-testid="product-family-growth"
                        className="fp-card-shadow flex h-full flex-col rounded-3xl bg-[#0B1F44] p-10 lg:p-12"
                    >
                        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#2563EB]">
                            <TrendingUp className="h-6 w-6 text-white" />
                        </span>
                        <h3 className="mt-8 text-sm font-semibold uppercase tracking-wider text-[#60A5FA]">
                            FlowPilot Growth
                        </h3>
                        <p className="mt-4 max-w-lg text-xl font-semibold leading-relaxed text-white lg:text-2xl">
                            Generate qualified enquiries, improve follow-up and
                            connect marketing activity to revenue.
                        </p>
                        <div className="mt-auto pt-10">
                            <a
                                href="#growth-review"
                                data-testid="growth-family-cta"
                                onClick={() => trackCTAClick("product_families")}
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#2563EB] px-7 py-3.5 text-base font-semibold text-white transition-colors hover:bg-blue-600"
                            >
                                Book a 20-minute Growth Review
                                <ArrowRight className="h-4 w-4" />
                            </a>
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <div
                        data-testid="product-family-ops"
                        className="fp-card-shadow flex h-full flex-col rounded-3xl border border-gray-100 bg-[#F8FAFC] p-10"
                    >
                        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#2563EB]/10">
                            <Briefcase className="h-6 w-6 text-[#2563EB]" />
                        </span>
                        <h3 className="mt-8 text-sm font-semibold uppercase tracking-wider text-[#2563EB]">
                            FlowPilot Ops
                        </h3>
                        <p className="mt-4 text-base leading-relaxed text-[#4B5563]">
                            AI-supported finance and business operations that
                            help businesses improve billing, receivables,
                            working capital, exception handling and management
                            visibility.
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
